/**
 * First-letter initials from any name (max two letters: first +
 * last). Mirrors `ManagerAvatar.getManagerInitials` in trusstor_dashboard.
 */
export function nameInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '';
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0]![0]!.toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
